/**
 * Action used to store the flag signaling the endpoint has been counted.
 */
export const SET_ENDPOINT_COUNTED = 'SET_ENDPOINT_COUNTED';
